import { lazy, Suspense } from 'react';

import { AppRoutes } from '../paths';
import IntroPage from '../../pages/intro-page';
import { AuthOutlet } from '../../auth/auth-route';
import LandingPage from '../../pages/landing-page';
import { ResourceManagerRoute } from '../../auth/route-guards/resource-manager-route';

// ----------------------------------------------------------------------

const ProfileSelectionPage = lazy(() => import('../../pages/quiz/profile-selection-page'));
const QuestionPage = lazy(() => import('../../pages/quiz/question-page'));
const DashboardPage = lazy(() => import('../../pages/dashboard-page'));
const LibraryPage = lazy(() => import('../../pages/library-page'));
const ResourceManagerPage = lazy(() => import('../../pages/resource-manager-page'));
const TopicManagerPage = lazy(() => import('../../pages/topic-manager-page'));

// ----------------------------------------------------------------------

export const privateRoutes = [
  {
    path: AppRoutes.LANDING_PAGE,
    element: (
      // TODO: implement nicer loading screen for fallback
      <Suspense fallback={<></>}>
        <AuthOutlet />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: AppRoutes.QUIZ_PROFILE_SELECTION,
        element: <ProfileSelectionPage />,
      },
      {
        path: AppRoutes.QUIZ_QUESTION,
        element: <QuestionPage />,
      },
      {
        path: AppRoutes.DASHBOARD,
        element: <DashboardPage />,
      },
      {
        path: AppRoutes.LIBRARY,
        element: <LibraryPage />,
      },
      {
        path: AppRoutes.INTRO_PAGE,
        element: <IntroPage />,
      },
      {
        element: <ResourceManagerRoute />,
        children: [
          {
            path: AppRoutes.RESOURCE_MANAGER,
            element: <ResourceManagerPage />,
          },
          {
            path: AppRoutes.TOPIC_MANAGER,
            element: <TopicManagerPage />,
          },
        ],
      },
    ],
  },
];
